<template>
  <div class="info-primaire-produit h-100">
    <b-container class="p-0">
      <b-row class="padding-texte">
        <b-col class="flex-column infoJeu col-8 col-sm-7 col-xxl-8">
          <b-row class="graphik_bold card-header__category">
            <!--TODO: mettre le symbole pour indiquer la nouveauté du produit-->
            <div class="sur-titre" v-html="surTitre" />
          </b-row>
          <b-row
            class="card-header__title graphik_bold align-items-center titre pb-0"
            v-html="mixinProduitCasino_getTitre()"
          />
          <b-row>
            <div class="min-bet montant-mise" v-html="mixinProduitCasino_getMiseMinMax()" />
          </b-row>
        </b-col>
        <b-col class="d-flex bouton-jouer col-4 col-sm-5 col-xxl-4 pt-1">
          <div class="w-100 d-flex justify-content-end">
            <span @click.capture="gaPreventClick">
              <Hyperlien
                :aria-label="mixinProduitCasino_getTitre(false)"
                :content="{
                  texte: getTexteBoutonJouer,
                  type: 'boutonPrimaire',
                  theme: 'themeClair',
                  lien: content.produit.lienInternePageProduit,
                }"
              />
            </span>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';
import Hyperlien from '@/components/base/Hyperlien';

export default {
  name: 'CarteInfoPrimaireProduit',
  components: { Hyperlien },
  mixins: [mixinProduitCasino],
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          nouveaute: 'nouveauté',
        },
      },
      en: {
        messageComponent: {
          nouveaute: 'new',
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      isProduitCasinoNouveau: 'produitCasino/isNouveaute',
    }),
    // obligatoire pour pouvoir récupérer le produit sous mixinProduitCasino
    produit() {
      return this.content.produit;
    },
    surTitre() {
      if (this.isProduitCasinoNouveau(this.content.produit)) {
        return this.$t('messageComponent.nouveaute');
      }
      if (!this.content.cacherSurTitreCategorie) {
        return this.mixinProduitCasino_getCategorie() || '&nbsp;';
      }
      return '&nbsp;';
    },
    getTexteBoutonJouer() {
      return `${this.$t(
        'jouer'
      )} <span class='sr-only'>${this.mixinProduitCasino_getTitre()}</span>`;
    },
  },
  methods: {
    gaPreventClick(event = null) {
      const emplacement = this.jel_gaGetEmplacement();

      // Ajout datalayer pour ajouter Event click vers Google Analytics
      if (emplacement.indexOf('Collection') === -1) {
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event: this.content.gaEvent,
          categorie: this.content.gaCategorie,
          emplacement,
          libelle: this.content.gaTitreProduit,
          position: this.content.gaPosition,
        });
      }
    },
    lancerJeu() {
      console.debug('page de jeux');
    },
    isPageJeux() {
      return window.location.href.includes('/casino/p/');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: none;
  padding: 16px;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}

.col {
  padding: 0;
}

.card-header__category {
  color: $gris-casino;
  text-transform: uppercase;
  font-size: 0.8125rem;
  display: block;
  /* These to prevent long text to extend the card */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-header__title {
  padding-top: 0.1rem;
  color: $noir-casino;
  line-height: 1.25rem;
  /*
  The next four lines create an elipsis
  on webkit after 2 lines. Other browsers
  should not see the rest of the title.
  */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.min-bet {
  margin-left: 0;
  color: $noir-casino;
  opacity: 0.7;
  display: inline;
  list-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8125rem;
}

.produitDesactive .bouton-jouer ::v-deep a.btn.btn-primaire {
  color: #d7deea;
}

@media screen and (min-width: 375px) {
  .info-primaire-produit {
    height: 150px;
  }
}

@media screen and (min-width: 768px) {
  .info-primaire-produit {
    height: 112px;
  }
}

.sur-titre {
  letter-spacing: -0.01em;
  padding-top: 0.1rem;
}
.titre,
.montant-mise {
  letter-spacing: $letter-spacing-n1;
}

.titre {
  padding-top: 0;
}

::v-deep .btn-primaire {
  font-family: graphik_bold;
  text-transform: uppercase;
}
</style>
